import React, { useState, useEffect, useContext } from 'react'

import { NavigationContext } from '../../../shared/ui/NavigationController'
import DialogBox from '../../../shared/ui/DialogBox'
import InputField from '../../../shared/ui/InputField'
import Link from '../../../shared/ui/Link'
import Button from '../../../shared/ui/Button'

import { withStyles } from '@material-ui/core/styles'
import { Typography, Box } from '@material-ui/core'


const styles = theme => ({
    
})

const ProposalSelectForm = ({ theme, classes, children, onClose, onConfirm, ...props }) => {

  const navigationContext = useContext(NavigationContext)
  const [formData, setFormData] = useState({})

  const onChange = (fieldName) => (value) => {
    let newFormData = {
      ...formData,
      [fieldName]: value
    }
    
    setFormData(newFormData)
  }

  const confirmAgreement = () => {
    if (formData.agree) {
      navigationContext.showLoadingDialog(true)
  
      onConfirm()
    } else {
      alert("You have to agree to Terms and Conditions")
    }
  }

  let agreementButtons = [
    <Button variant='contained' fullWidth onClick={onClose} color="default">
      Cancel
    </Button>,
    <Button variant='contained' fullWidth onClick={confirmAgreement} color="primary">
      Confirm
    </Button>
  ]

  return (
    <DialogBox show={true} onClose={onClose} actionButtons={agreementButtons}>
      <Typography variant='body1'>
        By checking box below you agree to the Terms and Conditions
      </Typography>
      <Box className={classes.formControl} style={{width:'100%'}}>
      <InputField
        fieldName='agree'
        type='checkbox'
        labelStyle={{ zIndex: 3 }}
        label={
        ( 
        <Typography variant='body1'> 
          I agree with PasarTrainer 
          <Link style={{ textDecoration:'underline' }} to={'/page/terms-and-conditions'} target={'_blank'}>
            Terms and Conditions
          </Link> 
        </Typography> )
        }
        value={formData.agree}
        onChange={onChange('agree')}
        />
      </Box>
    </DialogBox>
  )
}

export default withStyles(styles, { withTheme: true })(
    (ProposalSelectForm)
)
